import React from "react";

export class Backdrop extends React.Component<{ className?: string, onClick: any }, any> {
	private element: HTMLElement|null = null;

	componentDidMount() {
		const element = document.createElement('div');
		element.className = this.props.className ? this.props.className : 'task-card__backdrop';
		element.onclick = this.props.onClick;
		element.role = "presentation";
		document.body.appendChild(this.element = element);

	}

	componentWillUnmount() {
		if ( this.element) {
			this.element.remove();
		}
	}

	render() {
		return null;
	}
}